import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContractorService {

  constructor(private http: HttpClient) { }


  GetRecord(): Observable<Array<General_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Contractor").pipe(
      map(data => {
        return data as Array<General_Interface>
      })
    )
  }


  GetActiveList(): Observable<Array<General_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Contractor/GetActiveList").pipe(
      map(data => {
        return data as Array<General_Interface>
      })
    )
  }

  GetSingle(id: Number): Observable<General_Interface> {
    return this.http.get(environment.BaseUrl + "Daro/Contractor/GetSingle?id=" + id).pipe(
      map(data => {
        return data as General_Interface
      })
    )
  }

  GetCustomer(id: Number): Observable<Array<General_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Contractor/GetCustomer?id=" + id).pipe(
      map(data => {
        return data as Array<General_Interface>
      })
    )
  }

  GetCustomerActiveList(id: Number): Observable<Array<General_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Contractor/GetCustomerActiveList?id=" + id).pipe(
      map(data => {
        return data as Array<General_Interface>
      })
    )
  }

  AddContractor(model: General_Interface): Observable<General_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id: model.id,
      title: model.title,
      del: false,
      username: '',
      subdate: null
    }


    return this.http.post(environment.BaseUrl + "Daro/Contractor/Add", body, { headers }).pipe(
      map(data => {
        return data as General_Interface
      })
    )

  }

  EditContractor(model: General_Interface): Observable<General_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id: model.id,
      title: model.title,
      del: false,
      username: '',
      subdate: null
    }


    return this.http.post(environment.BaseUrl + "Daro/Contractor/Edit", body, { headers }).pipe(
      map(data => {
        return data as General_Interface
      })
    )

  }

  DeleteContractor(id: number): Observable<General_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/Contractor/Delete?id=" + id ).pipe(
      map(data => {
        return data as General_Interface
      })
    )

  }

  DeleteCustomer(id: number): Observable<General_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/Contractor/DeleteCustomer?id=" + id ).pipe(
      map(data => {
        return data as General_Interface
      })
    )

  }


  AddCustomer(contractor_id: number,customer_id:number):Observable<General_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:0,
      contractor_id:contractor_id,
      customer_id:customer_id,
      username:'',
    }


      return this.http.post(environment.BaseUrl + "Daro/Contractor/AddCustomer",body,{headers}).pipe(
        map(data=>{
          return data as General_Interface
        })
      )

  }

}
